import Icon from '../components/Icon.vue'

Icon.register({
  key: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 176c0 97.2-78.8 176-176 176-11.2 0-22.2-1.1-32.8-3.1l-24 27c-4 4.4-12 8.1-17.9 8.1h0-37.2v40c0 13.3-10.7 24-24 24h-40v40c0 13.3-10.7 24-24 24h-112c-13.3 0-24-10.7-24-24v-78.1c0-6.4 2.5-12.5 7-17l161.8-161.8c-5.7-17.4-8.8-35.9-8.8-55.2 0-97.2 78.8-176 176-176 97.5 0 176 78.5 176 176zM336 128c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/key.js
// module id = 1496
// module chunks = 0